export default __webpack_public_path__ + "static/media/dj-product-compare-bg.916139ab.svg";